import { useRouter } from "next/router"
import { useMemo } from "react"

import { StakeType } from "@/stake/types"

const stakeTypeValues = Object.values(StakeType)
type StakeTypeValue = {
  stakeType: StakeType | undefined
  isLiquid: boolean
  isNative: boolean
}
const useStakeType = (): StakeTypeValue => {
  const router = useRouter()
  const { stakeType } = router.query

  const value = useMemo(() => {
    if (!stakeType || !stakeTypeValues.includes(stakeType as StakeType)) {
      return { stakeType: undefined, isLiquid: false, isNative: false }
    }

    return {
      stakeType: stakeType as StakeType,
      isLiquid: stakeType === StakeType.LIQUID,
      isNative: stakeType === StakeType.NATIVE,
    }
  }, [stakeType])

  return value
}

export default useStakeType
